import React from "react";
import { ThemeProvider } from "styled-components";

const theme = {
  colors: {
    white: "#FFFFFF",
    red: "#fe3729",
    buttonFormRed: "#FF0000",
    yellow: "#ffaa06",
    blue: "#00316d",
    secondaryBlue: "#265EA3",
    headerTextBlue: "#00306C",
    blue50: "#009DFF",
    systemBlue: "#007AFF",
    textBlue: "#00326E",
    buttonBlue: "#00326E",
    iconBlue: "#00326E",
    badgeBlue: "#00326E",
    black: "#000000",
    black50: "#F2F2F2",
    black60: "#e8edf8",
    black70: "#33363F",
    black100: "#E5E5E5",
    black500: "#808080",
    black900: "#1A1A1A",
    black700: "#4D4D4D",
    black800: "#333333",
    bgWhite: "#FAFBFF",
    borderGray: "#CECECE",
    buttonFormBlue: "#0147A1",
    formBorderColor: "#D8DCE3",
    buttonRed: "#FC0B1B",
    secondaryRed: "#FF0000",
    tableColumnText: "#818181",
    tableBodyBackground: "#F8F8F8",
    tableRowHoverBackground: "#FCFCFC",
    tableRowHighlightBlue: "#00326E",
    pendingStatus: "#4252c9",
    requestedStatus: "#f3c61c",
  },
  screens: {
    sm: "576px",
  },
};

const Theme = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
